/**
 * Composant principal pour la planification.
 * Intègre un sous-touting pour les pages/composant : Daily, availability, unavailibility.
 */

import { Component, OnInit } from '@angular/core';
import { AchievementService } from '../../../../shared/src/lib/service/achievement.service';
import { AchievementDoneservice } from '../../../../shared/src/lib/service/achievementDone.service';
import { AchievementManagerService } from '../../../../shared/src/lib/service/achievementManager.service';
import { Achievement } from '../../../../shared/src/lib/model/achievement.model';
import { AuthenticationService } from '../../../../shared/src/lib/service/authentification.service';
import { Teacher } from '../../../../shared/src/lib/model/teacher.model';
import { HelpNotifManagerService } from '../../../../shared/src/lib/service/helpNotifManagerService';

@Component({
  selector: 'app-schedule',
  templateUrl: './schedule.component.html',
  styleUrls: ['./schedule.component.scss']
})
export class ScheduleComponent implements OnInit {
  isSchedule = true;

  achievement: Achievement = null;
  helps = [];
  canFire = false;
  teacher: Teacher = null;

  device: string;

  constructor(
    private achievementManagerService: AchievementManagerService,
    private authenticationService: AuthenticationService,
    private helpNotifManagerService: HelpNotifManagerService,
    private achievementDoneservice: AchievementDoneservice,
    private achievementService: AchievementService,
    private authentification: AuthenticationService,
  ) { }

  ngOnInit() {
    this.device = this.authentification.getDeviceMode();

    this.authenticationService.currentUserSubject.subscribe(_current_user => {
      this.teacher = _current_user;
    });

    this.getCalendarAchievement(this.teacher.achievements);
    this.achievementManagerService.achievementToFire.subscribe(val => {
      if (this.achievement && val) {
        if (this.achievementManagerService.canFire(this.achievement)) {
          this.helpNotifManagerService.setHelpNotif(this.achievement);
          this.canFire = true;
        }
      }
    })
  }

  getCalendarAchievement(achievements: Achievement[]) {
    if (achievements) {
      if (achievements.length > 0) {
        this.achievement = achievements.filter(a => a.slug === 'calendar-tooltip' ? a : null)[0];
      }
    }
  }

  postAchivement() {
    this.achievementManagerService.setAchievementAsFire(this.achievement);
    let _params = {
      achievement: this.achievement.url,
      content_type_model: 'teacher',
      object_id: this.teacher.id
    }
    this.achievementDoneservice.postAchievementDone(_params).subscribe(achievementDone => {
      this.achievement.achievements_done = achievementDone.created_at;
      this.achievementService.updatePersonaAchievement(this.teacher, this.achievement);
    })
  }
}
